const state = () => ({
    records: [],
    fileId: String,
    fileName: String,
    areFileRecordsLoading: true,
    daysRange: {
        from: '',
        to: '',
    },
    rows: [],
    doubleRows: [],
    hasModalError: false,
    modalErrorMessage: ''
});

const getters = {};

const actions = {};

const mutations = {
    setFileId(state, val) {
        state.fileId = val;
    },

    setFileName(state, val) {
        state.fileName = val;
    },

    setRecords(state, val) {
        state.records = val;
    },

    toggleFileRecordsLoading(state, val) {
        state.areFileRecordsLoading = val;
    },

    updateDaysRange(state, val) {
        state.daysRange.from = val.from;
        state.daysRange.to = val.to;
    },

    setTableRows(state, val) {
        state.rows = val;
    },
    
    setTableDoubleRows(state, val) {
        state.doubleRows = val;
    },
        
    enableModalError(state) {
        state.hasModalError = true;
    },

    disableModalError(state) {
        state.hasModalError = false;
    },

    updateModalError(state, message) {
        state.modalErrorMessage = message;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
